export default "__VITE_PUBLIC_ASSET__bd52084d__"